import React, { CSSProperties } from 'react';

import styles from './Spinner.module.scss';

type Props = {
    style?: CSSProperties,
};

export default function Spinner({ style }: Props) {
    return (
        <div className={styles.container} style={style}>
            <div className={styles.spinner}>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
            </div>
        </div>
    );
}
